<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Các chương học</h2>
        <!-- <el-button @click="createModel" size="small" type="info" class="btn-create">Thêm mới chương học</el-button> -->
      </div>
    </el-row>
    <el-row>
      <div class="model-pagination">
          <div>
            Tổng số: <strong>{{ table.pagination.total }}</strong> chương học
          </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table
          v-loading="loading"
          border
          :data="table.database"
          style="width: 100%">
          <el-table-column
          width="100"
            label="STT">
            <template slot-scope="scope">
              <span>Chương {{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Tên chương">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            label="Trạng thái">
            <template slot-scope="scope">
              <div v-if="scope.row.status" class="item_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
              <div v-else class="item_not_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Kích hoạt"
            width="80"
            align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                @change="changeStatus(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            width="180"
            label="Hành động"
            header-align="center">
            <template slot-scope="scope">
              <div class="module-action">
                <el-tooltip effect="dark" content="Xem" placement="top">
                  <span @click="showModel(scope.row)">
                    <i class="fas fa-search icon-search"></i>
                  </span>
                </el-tooltip>
                <!-- <el-tooltip effect="dark" content="Sửa" placement="top">
                  <span @click="updateModel(scope.row)">
                    <i class="far fa-edit icon-update"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Xóa" placement="top">
                  <span @click="confirmDeleteModel(scope.row)">
                    <i class="far fa-trash-alt icon-delete"></i>
                  </span>
                </el-tooltip> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'Chapters',
  data () {
    return {
      loading: false,
      filter: {
        q: '',
        status: '',
        course_id: 0,
        page: 1,
        limit: 200,
        sort: 'id:1',
        sorted: '',
        include: ''
      },
      table: {
        database: [],
        meta_pagination: 0,
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        }
      }
    }
  },
  mounted () {
    this.filter.course_id = this.$route.params.course_id
    this.fetchDatabaseModel()
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    // Nút tạo Model
    createModel () {
      this.$router.push({name: 'chapters-create', params: {course_id: this.$route.params.course_id}})
    },
    // Fetch dữ liệu
    fetchDatabaseModel () {
      this.loading = true
      axios.get('chapters', {params: this.filter}).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination () {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
    // Xem chi tiết
    showModel (model) {
      this.$router.push({name: 'chapters-show', params: {chapter_id: model.id, course_id: this.$route.params.course_id}})
    },
    updateModel (model) {
      this.$router.push({name: 'chapters-update', params: {chapter_id: model.id, course_id: this.$route.params.course_id}})
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeStatus (model) {
      let dataUpdate = {
        'status': model.status
      }
      axios.post('chapters/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // confirmDeleteModel
    confirmDeleteModel (model) {
      this.$confirm('Xác nhận xóa chương học: ' + model.name, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel (model) {
      axios.delete('chapters/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal (model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/chapters/Index.vue